import axios from 'axios';

const basePath = '/web-api/movies';


export const list = (payload) => {
    return axios.post(
        basePath + '/list' ,
            payload
        );
}

export const all = (payload, config = {}) => {
    return axios.get(
        basePath + '/' + payload.country +
        '?page='+payload.page +
        '&limit='+payload.limit +
        '&search='+payload.searchData,
        config
    );
}

export const findMovie = (payload, config = {}) => {

    return axios.get(
        basePath + '/' + payload.country + '/' + payload.slug,
        config
    );
}

export default {
    list,
    all,
    findMovie,
}